/**
 * Build a page-number sequence with sliding window + ellipsis for deep lists.
 * Returns numbers and the string 'ellipsis' for gaps.
 */
export function buildPageSequence(page, pageCount, windowSize = 2) {
  if (pageCount <= 0) return [];
  if (pageCount === 1) return [1];

  const pages = new Set([1, pageCount, page]);
  for (let i = Math.max(1, page - windowSize); i <= Math.min(pageCount, page + windowSize); i++) {
    pages.add(i);
  }

  const sorted = [...pages].sort((a, b) => a - b);
  const result = [];
  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) result.push('ellipsis');
    result.push(sorted[i]);
  }
  return result;
}
